import Plyr from "plyr/src/js/plyr.polyfilled";

import "plyr/dist/plyr.css";
import "./styles.scss";

export default Plyr;
